module.exports = __webpack_public_path__ + "img/xcx-code.892582c6.png";